import Immutable from 'immutable';

const Content: {
  id: string,
  name: string,
  icon: string,
  url: string
} = {
  id: '',
  name: '',
  icon: '',
  url: ''
};

class WebApp extends Immutable.Record(Content) {
}

export default WebApp;
